import React, { useState } from "react";

const menuList = [
  { label: "TRANG CHỦ", href: "/" },
  { label: "GIỚI THIỆU", href: "/gioi-thieu" },
  {
    label: "SẢN PHẨM",
    href: "",
    children: [
      { label: "FORD TERRITORY", href: "/danh-sach/territory" },
      { label: "FORD EVEREST", href: "/danh-sach/everest" },
      { label: "FORD EXPLORER", href: "/danh-sach/explorer" },
      { label: "FORD RANGER", href: "/danh-sach/ranger" },
      { label: "FORD TRANSIT", href: "/danh-sach/transit" },
    ],
  },
  {
    label: "DỊCH VỤ",
    href: "/dich-vu", // Giữ href để vẫn có thể điều hướng nếu không có children
    children: [
      { label: "ĐẶT LỊCH BẢO DƯỠNG", href: "/dat-lich-bao-duong" },
      { label: "GIỚI THIỆU DỊCH VỤ", href: "/gioi-thieu-dich-vu" },
      { label: "BẢO DƯỠNG ĐỊNH KỲ", href: "#" },
      { label: "CHÍNH SÁCH BẢO HÀNH", href: "/bao-hanh-tieu-chuan" },
      { label: "PHỤ TÙNG & PHỤ KIỆN CHÍNH HÃNG", href: "/phu-tung-phu-kien" },
      { label: "CHĂM SÓC KHÁCH HÀNG", href: "#" },
    ],
  },
  {
    label: "TƯ VẤN",
    href: "",
    children: [{ label: "MUA XE TRẢ GÓP", href: "/san-pham/xe-du-lich" }],
  },
  {
    label: "TIN TỨC",
    href: "/tin-tuc",
    children: [
      { label: "TIN TỨC NỘI BỘ", href: "#" },
      { label: "TIN TỨC THỊ TRƯỜNG", href: "#" },
    ],
  },
  { label: "LIÊN HỆ", href: "/lien-he" },
];

const MenuNav = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="menu-container">
      <div className="menu-toggle" onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}>
        ☰ MENU
      </div>

      <nav className={`menu-nav ${isMobileMenuOpen ? "open" : ""}`}>
        {menuList.map((item, index) => (
          <div className="menu-item" key={index}>
            <a
              href={item.href || "#"}
              className="menu-link"
            >
              {item.label}
              {/* Giữ mũi tên chỉ để hiển thị có children */}
              {item.children && <span className="arrow"> ▼</span>}
            </a>

            {item.children && (
              <div className={`dropdown`}>
                {item.children.map((child, idx) => (
                  <a href={child.href} className="dropdown-item" key={idx}>
                    {child.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>

      <style>{`
        .menu-container {
          background: #0057b8;
        }

        .menu-toggle {
          display: none;
          padding: 10px 20px;
          background: #0071dc;
          color: white;
          cursor: pointer;
          font-weight: bold;
        }

        .menu-nav {
          display: flex;
          font-weight: bold;
          text-transform: uppercase;
          font-size: 14px;
        }

        .menu-item {
          position: relative;
        }

        .menu-item:hover {
          background: #E5E5E5
        }

        .menu-link {
          text-decoration: none;
          padding: 10px 20px;
          display: inline-block;
          color: #fff
        }

        .menu-link:hover {
          color: #0071dc;
        }

        .arrow {
          font-size: 10px;
          margin-left: 4px;
        }

        /* --- Desktop Styles (Giữ nguyên) --- */
        .dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          background: white;
          border: 1px solid #ddd;
          min-width: 200px;
          display: none; /* Mặc định ẩn trên desktop */
          flex-direction: column;
          box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          z-index: 1000;
        }

        .dropdown-item {
          padding: 10px 15px;
          color: #333;
          text-decoration: none;
        }

        .dropdown-item:hover {
          background-color: #f2f2f2;
        }

        .menu-item:hover .dropdown {
          display: flex; /* Hiện khi hover trên desktop */
        }

        /* --- Mobile Styles (Cập nhật) --- */
        @media (max-width: 768px) {
          .menu-toggle {
            display: block;
          }

          .menu-nav {
            flex-direction: column;
            display: none;
          }

          .menu-nav.open {
            display: flex; /* Khi menu chính mở */
          }

          .menu-item {
            width: 100%;
          }

          .dropdown {
            position: static;
            border: none;
            box-shadow: none;
            padding-left: 20px; /* THÊM VÀO ĐÂY ĐỂ THỤT LỀ */
            display: flex;
            flex-direction: column;
            background: transparent;
          }

          .dropdown-item {
            padding: 8px 0;
            color: #fff;
          }

          .dropdown-item:hover {
            background-color: transparent;
            color: #0071dc;
          }

          .menu-nav.open .dropdown {
               display: flex;
           }

           .menu-item:hover .dropdown {
                display: flex !important;
           }

           .menu-link .arrow {
                display: none;
           }
        }
      `}</style>
    </div>
  );
};

export default MenuNav;